import {
  ApiResponse,
  ApiResponseState,
  Appointment,
  AppointmentReasons,
  AppointmentStatus,
  BasicPatientInfo,
  ClinicData,
  CreateInvestigation,
  DepartmentDetail,
  File_Source_Req,
  File_Source_Res,
  Gender,
  loginDetails,
  PaginatedResponse,
  PastIllnessDetail,
  Patient,
  PatientInvestigationDetail,
  PatientList,
  PatientResponse,
  Patientv2,
  StoreData,
  User,
  UserBasic,
  AdminConsoleToken,
  MedicalHistoryStatus,
  ApiResponseCity
} from '../types';
import {deleteRequest, getRequest, postRequest, putRequest, uploadFileToS3} from './httpService';
import axios from 'axios';
import {
  addinvestigationURL,
  addSexualHistoryURL,
  addSocialHistoryURL,
  appointments,
  departmentRooms,
  departmetnList,
  geGenderUrl,
  get_appointment_reasons,
  get_users,
  get_users_by_clinic,
  get_users_clinic,
  get_users_clinic_only,
  getappointmentaddictionsUrl,
  getappointmentallergysUrl,
  getappointmentsUrl,
  getClinicByIdUrl,
  getClinicsUrl,
  getcountrycodeUrl,
  getcountryUrl,
  getDelinkUrl,
  getDoctorsList,
  getfamilyhistoryUrl,
  getLabTestsCatsURL,
  getLabTestsURL,
  getLinkPartnerUrl,
  getMainMedicalHistoryURL,
  getmedicalhistoryUrl,
  getMyProfileUrl,
  getpastillnessUrl,
  getpastmedicationhistoryUrl,
  getPatientApiUrl,
  getPatientApiUrlById,
  getProceduresURL,
  getputgeneralsystemexaminationURL,
  getputinfertilityassessmentURL,
  getputpastillnessUrl,
  getputpriorinfertilitytestingUrlUrl,
  getputpriorinfertilitytreartmentUrl,
  getputSurgicalHistoryURL,
  getputurogenitalexaminationURL,
  getputvitalURL,
  getSocialHistoryURL,
  getStateUrl,
  getUploadURL,
  getUserUrl,
  getvaccinationUrl,
  getWorkingHoursURL,
  loginUserUrl,
  operationTheaterTables,
  postNewRegistrationUrl,
  postpastillnessUrl,
  previousVisitLogs,
  putappointmentaddictionsUrl,
  putappointmentallergysUrl,
  putappointmentpreviousinvestigationhistoryUrl,
  putMainMedicaHistoryURL,
  putpriorinfertilitytestingUrl,
  status,
  getAdminUrl,
  getPatientApiAndroUrl,
  getOocyteUploadURL,
  getEmbryoUploadURL,
  deleteInvestigationURL,
  getmedicalhistoryStatusUrl,
  getPatientFullList,
  getClinicalPatients,
} from './urls';

import {AxiosResponse} from 'axios';

import {useEffect, useState} from 'react';
import {formatDate} from './userService';
import {convertDateToISOWithOffset, formatDateToLocalYYYYMMDD} from './time';
import {OutOfOfficeRequest} from '../components/calendarComponent/Calendar.helper';
import { FileFollicularReq, FileFollicularReqV2, UploadFileResponse, UploadFileResponseV2 } from '../pages/Stim/helper.stim';
import { MasterItem } from '../utils/commonUtils';
import { LiveBirthPredictionRequest, LiveBirthPredictionResponse, LiveBirthChatRequest, PatientCycleData } from '../types';
import { AI_SERVICE_BASE_URL } from '../config/externalUrls';

// Purpose: Contains functions that make requests to the API.
export function getUser(name: string): Promise<string> {
  return getRequest(getUserUrl(name), { responseType: 'text' });
}

export function getUserDetailsById(id: number): Promise<UserBasic> {
  return getRequest(`${get_users()}${id}`);
}

export function getUserById(id: string, clinic: string, department: string) {
  getRequest(`${get_users_clinic(clinic, department)}/${id}`);
}

export function loginUser(loginData: loginDetails): Promise<string> {
  return postRequest<'json'>(loginUserUrl(),loginData);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function fetchPatientList(query: string, clinic__id: string): Promise<any> {
  const url = getPatientApiUrl();
  // Only append &is_lead=false if 'is_lead' is not already present in the query
  const hasIsLead = /(^|&|\?)is_lead(=|&|$)/.test(query);
  const isLeadParam = hasIsLead ? '' : '&is_lead=false';
  return await getRequest(`${url}?${query}&clinic=${clinic__id}&limit=10${isLeadParam}`, { responseType: 'json' });
}


// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function fetchPatientFullList(query: string, clinic__id: string, options?: { signal?: AbortSignal }): Promise<any> {
  const url = getPatientFullList();
  const response = await getRequest(`${url}?${query}&clinic=${clinic__id}`, { responseType: 'json', ...(options?.signal ? { signal: options.signal } : {}) });
  return response;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function fetchPatientListAndro(query: string, clinic__id: string): Promise<any> {
  const url = getPatientApiAndroUrl();
  return await getRequest(`${url}?${query}&clinic=${clinic__id}`, {responseType: 'json'});
}
export async function fetchCheckedInPatients(query:string, clinic__id: string):Promise<PaginatedResponse<PatientList[]>>{
  const url = getPatientApiUrl(); 
  
  // Temporary commented because getting 500 respose 
  // const url = 'appointments/clinical-patients/';  

  return await getRequest(`${url}?${query}&clinic=${clinic__id}`, {responseType: 'json'});
}

export async function fetchClinicalCheckedInPatients(query:string, clinic__id: string):Promise<PaginatedResponse<PatientList[]>>{
  const url = getClinicalPatients(); 
  return await getRequest(`${url}?${query}&clinic=${clinic__id}`, {responseType: 'json'});
}


export function getGender(): Promise<PaginatedResponse<Gender[]>> {
  return getRequest(geGenderUrl(), { responseType: 'json' });
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function postPatientPartnerInfo(data:any): Promise<Patientv2> {
  return postRequest<Patientv2>(postNewRegistrationUrl(),data, { responseType: 'json' });
}

export function getLinkPatientList(query: string, clinic__id: string): Promise<PaginatedResponse<Patient[]>> {
  return getRequest(`${getPatientApiUrl()}?${query}&clinic=${clinic__id}&limit=30`, { responseType: 'json' });
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function postLinkPartner(partnerId: any, data: any): Promise<AxiosResponse<PatientResponse>> {
  return postRequest(getLinkPartnerUrl(partnerId), data, { responseType: 'json' });
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function postDelink(patientId: any, data: any): Promise<string> {
  return postRequest(getDelinkUrl(patientId), data, { responseType: 'json' });
}

export function getcountryList(): Promise<ApiResponse> {
  return getRequest(getcountryUrl(), { responseType: 'json' });
}

export function getCountryStateList(selectedCountry: string): Promise<ApiResponseState> {
  const url = `${getStateUrl()}?country=${encodeURIComponent(selectedCountry)}`;
  return getRequest(url, { responseType: 'json' });
}

export function getStateCityList(selectedState: string): Promise<ApiResponseCity> {
  const url = `cities?state=${encodeURIComponent(selectedState)}`;
  return getRequest(url, { responseType: 'json' });
}


export function getStateList(): Promise<ApiResponse> {
  return postRequest(getStateUrl(), { responseType: 'json' });
}
export function getPatientDetails(id: string, query?:string): Promise<Patientv2> {
  return getRequest(getPatientApiUrlById(id, query), { responseType: 'json' });
}

export function getPatientName(id: string): Promise<BasicPatientInfo> {
  return getRequest(getPatientApiUrlById(id), { responseType: 'json' });
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function updatePatient(id: string,data:any): Promise<BasicPatientInfo> {
  return putRequest(getPatientApiUrlById(id),data, { responseType: 'json' });
}

 
export function getMyProfile(): Promise<User> {
  return getRequest<User>(getMyProfileUrl(), { responseType: 'json' });
}

export function getMyProfileBasic(): Promise<UserBasic> {
  return getRequest<UserBasic>(getMyProfileUrl(), { responseType: 'json' });
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function uploadFileURL(req: File_Source_Req, file: File):Promise<any> {
  return postRequest<File_Source_Res>(getUploadURL(), req, { responseType: 'text' })
    .then((response: File_Source_Res) => { 
      return uploadFileToS3(file, response.presigned_url);
    });
}


export function uploadFileURLV2(req: FileFollicularReq, file: File):Promise<UploadFileResponse> {
  return postRequest<UploadFileResponse>('follicular-study-results/upload-images/', req, { responseType: 'text' })
    .then((response: UploadFileResponse) => {
      uploadFileToS3(file, response.presigned_url);
      return response;
    });
}

export function uploadFileURLV3(req: FileFollicularReqV2):Promise<UploadFileResponseV2> {
  return postRequest<UploadFileResponseV2>('follicular-study-results/', req, { responseType: 'text' })
    .then((response: UploadFileResponseV2) => {
      return response;
    });
}

export function createFollicularSTudy(req: FileFollicularReq) {
  return postRequest('follicular-study-results/upload-images/', req, { responseType: 'text' });
}


// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getcountrycode(): Promise<any> {
  return getRequest(getcountrycodeUrl(), { responseType: 'json' });
}


// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getDoctors(name: string = '', limit: number = 10): Promise<any> {
  const url = `${getDoctorsList()}?limit=${limit}&name__icontains=${name}`;
  return getRequest(url, { responseType: 'json' });
}

export function getAppointments(query: string, viewDateFrom: Date | null | undefined, viewDateTo: Date | null | undefined, clinic_id: string): Promise<PaginatedResponse<Appointment[]>> {
  if (viewDateFrom && viewDateTo) {
    const startDate = formatDateToLocalYYYYMMDD(viewDateFrom);
    const endDate = formatDateToLocalYYYYMMDD(viewDateTo);
    return getRequest(`${getappointmentsUrl()}?${query}&appointment_date_after=${startDate}&appointment_date_before=${endDate}&type=APPOINTMENT&clinic__id=${clinic_id}`);
  }
  return getRequest(`${getappointmentsUrl()}?${query}`);
}

export function getAppointmentsOOO({ clinic_id, department__id, appointment_date_before, appointment_date_after }: { clinic_id: string; department__id?: number; appointment_date_before?: string; appointment_date_after?: string }): Promise<PaginatedResponse<Appointment[]>> {
  
  const event_type = 'OUT_OF_OFFICE';
  const order_by = 'end_datetime';
  const limit = 1000;
  return getRequest(
    `${getappointmentsUrl()}?limit=${limit}&order_by=${order_by}&type=${event_type}&clinic__id=${clinic_id}&department__id=${department__id ?? ''}&appointment_date_before=${appointment_date_before ?? ''}&appointment_date_after=${appointment_date_after ?? ''}`
  );
}


// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function addSexualHistory(id: number,data:any): Promise<any> {
  return putRequest(addSexualHistoryURL(id),data, { responseType: 'json' });
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getSexualHistory(id: number): Promise<any> {
  return getRequest(addSexualHistoryURL(id), { responseType: 'json' });
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getSocialHistory(id: number): Promise<any> {
  return getRequest(getSocialHistoryURL(id), { responseType: 'json' });
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function addSocialHistory(id: number,data:any): Promise<any> {
  return putRequest(addSocialHistoryURL(id),data, { responseType: 'json' });
}

export function getAppointmentsList({tenantId, departmentID, patientId, afterDate,beforeDate, status, offset, limit, search, signal}:{tenantId?: string, departmentID?: number, patientId?:number, afterDate?:string, beforeDate?: string, status?:string, offset?: number, limit?: number, search?: string, signal?: AbortSignal}):
  Promise<PaginatedResponse<Appointment[]>>{
  let url = `${getappointmentsUrl()}?limit=${limit ?? 1000}&order_by=-end_datetime`;

  if (tenantId) {
    url += `&clinic_id=${tenantId}`;
  }
  if (patientId) {
    url += `&patient=${patientId}`;
  }
  if (afterDate) {
    url += `&appointment_date_after=${afterDate}`;
  }
  if (beforeDate) {
    url += `&appointment_date_before=${beforeDate}`;
  }

  if (departmentID) {
    url += `&department__id=${departmentID}`;
  }

  if (status) {
    url += `&status=${status}`;
  }
  if (offset) {
    url += `&offset=${offset}`;
  }
  if (search) {
    url += `&search=${search}`;
  }

  return getRequest(url, { signal });
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getappointmentallergysList(patientId: number): Promise<any> {
  return getRequest(getappointmentallergysUrl(patientId), { responseType: 'json' });
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function putappointmentallergysList(patientId: number, allergies: any[]): Promise<any> {
  return putRequest(putappointmentallergysUrl(patientId), allergies);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getappointmentaddictionsList(patientId: number): Promise<any> {
  return getRequest(getappointmentaddictionsUrl(patientId), { responseType: 'json' });
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function putappointmentaddictionsList(patientId: number, addiction: any[]): Promise<any> {
  return putRequest(putappointmentaddictionsUrl(patientId), addiction);
}


// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getappointmentpreviousinvestigationhistoryList(patientId: number): Promise<any> {
  return getRequest(putappointmentpreviousinvestigationhistoryUrl(patientId), { responseType: 'json' });
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function putappointmentpreviousinvestigationhistoryList(patientId: number, investigationHistory: any): Promise<any> {
  return putRequest(putappointmentpreviousinvestigationhistoryUrl(patientId), investigationHistory);
}


// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getpriorinfertilitytesting(patientId: number): Promise<any> {
  return getRequest(getputpriorinfertilitytestingUrlUrl(patientId), { responseType: 'json' });
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function putpriorinfertilitytesting(patientId: number, investigationHistory: any): Promise<any> {
  return putRequest(putpriorinfertilitytestingUrl(patientId), investigationHistory);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getpriorinfertilitytreatment(patientId: number): Promise<any> {
  return getRequest(getputpriorinfertilitytreartmentUrl(patientId));
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function putpriorinfertilitytratment(patientId: number, investigationHistory: any): Promise<any> {
  return putRequest(getputpriorinfertilitytreartmentUrl(patientId), investigationHistory);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function putMainMedicalHistory(patientId: number, data: any): Promise<any> {
  return putRequest(putMainMedicaHistoryURL(patientId), data);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getfamilyhistory(patientId: number): Promise<any> {
  return getRequest(getfamilyhistoryUrl(patientId), { responseType: 'json' });
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function putfamilyhistory(patientId: number, investigationHistory: any): Promise<any> {
  return putRequest(getfamilyhistoryUrl(patientId), investigationHistory);
}


// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getMainMedicalHistory(patientId: number): Promise<any> {
  return getRequest(getMainMedicalHistoryURL(patientId), { responseType: 'json' });
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getvaccination(patientId: number): Promise<any> {
  return getRequest(getvaccinationUrl(patientId), { responseType: 'json' });
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function putvaccination(patientId: number, investigationHistory: any): Promise<any> {
  return putRequest(getvaccinationUrl(patientId), investigationHistory);
}


// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getpastmedicationhistory(patientId: number): Promise<any> {
  return getRequest(getpastmedicationhistoryUrl(patientId), { responseType: 'json' });
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function putpastmedicationhistory(patientId: number, investigationHistory: any): Promise<any> {
  return putRequest(getpastmedicationhistoryUrl(patientId), investigationHistory);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getmedicalhistory(patientId: number): Promise<any> {
  return getRequest(getmedicalhistoryUrl(patientId), { responseType: 'json' });
}

export function getMedicalHistoryStatus(patientId: number): Promise<MedicalHistoryStatus> {
  return getRequest(getmedicalhistoryStatusUrl(patientId), { responseType: 'json' });
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getMedicalHistoryStatusDate(patientId: number): Promise<any> {
  return getRequest(getmedicalhistoryStatusUrl(patientId), { responseType: 'json' });
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function putmedicalhistory(patientId: number, investigationHistory: any): Promise<any> {
  return putRequest(getmedicalhistoryUrl(patientId), investigationHistory);
}

export function departmentsByClinic(clinic__id: string ): Promise<PaginatedResponse<DepartmentDetail[]>> {
  const url = `${departmetnList()}?limit=100&clinic__id=${clinic__id}`;
  return getRequest(url, { responseType: 'json' });
}

export function storesByClinic(clinic__id: string ): Promise<PaginatedResponse<StoreData[]>> {
  const url = `${departmetnList()}?limit=100&clinic__id=${clinic__id}`;
  return getRequest(url, { responseType: 'json' });
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function clinic(id: string): Promise<any> {
  return getRequest(getClinicByIdUrl(id), { responseType: 'json' });
}

export function clinics(): Promise<PaginatedResponse<ClinicData[]>> {
  return getRequest(getClinicsUrl(), { responseType: 'json' });
}

export function appointmentReasons({
  departmentId,
  clinicId,
  limit = 1000, // Default value for limit
}: Partial<{ departmentId: number; clinicId: number; limit: number }> = {}): Promise<PaginatedResponse<AppointmentReasons[]>> {
  const queryParams = new URLSearchParams();

  if (departmentId) queryParams.append('department', departmentId.toString());
  if (clinicId) queryParams.append('clinic', clinicId.toString());
  queryParams.append('limit', limit.toString()); // Always include limit

  const queryString = queryParams.toString();
  return getRequest(
    get_appointment_reasons() + (queryString ? '?' + queryString : ''),
    { responseType: 'json' }
  );
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function userList( limit: number = 10, searchTerm: string = ''): Promise<any> {
  const url = `${get_users()}?limit=${limit}&search=${searchTerm}&order_by=created_on`;
  return getRequest(url, { responseType: 'json' });
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function updateAppointment(id: number, data: any) : Promise<any> {
  const url = `${getappointmentsUrl()}${id}/`;
  return putRequest(url, {
    'appointment_date': data.appointment_date,
    'start_datetime': convertDateToISOWithOffset(new Date(`${data.appointment_date} ${data.start_datetime}:00`)),
    'end_datetime': convertDateToISOWithOffset(new Date(`${data.appointment_date} ${data.end_datetime}:00`)),
    'user': data.user,
    'appointment_reason': data.appointment_reason,
    'cancel_or_reschedule_reason': data.cancel_or_reschedule_reason,
    'patient': data.patient,
    ...(data?.patient?.partner && {'partner': data?.patient?.partner?.id,}),
  });
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function cancelAppointment(id: number, data: any) : Promise<any> {
  const url = `${getappointmentsUrl()}${id}/${status()}`;
  return putRequest(url, {
    'status': data.status,
    'remark': data.remark,
    'cancel_or_reschedule_reason': data.cancel_or_reschedule_reason
  });

}

export function cancelAppointmentOOO(id: number) : Promise<unknown> {
  const url = `${getappointmentsUrl()}${id}/${status()}`;
  return putRequest(url, {
    'status': AppointmentStatus.CANCELLED,
    'remark': 'Canceling OOO',
    'cancel_or_reschedule_reason': 'OOO Cancel'
  });

}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function postBookAppointment(data:any): Promise<any> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return postRequest<any>(`${appointments()}?force=true`,data, { responseType: 'json' });
}

export async function updateAppointmentDate(id: number, newStartDate: Date, newEndDate: Date) {
  const url = `${getappointmentsUrl()}${id}`;
  const appointment: Appointment = await getRequest(url);
  const reasons = await appointmentReasons().then((response) => response.objects);
  const reasonId = reasons.filter((reason: AppointmentReasons) => reason.reason.toUpperCase() === appointment.appointment_reason__reason.toUpperCase());
  return putRequest(url, {
    'appointment_date': formatDate(newStartDate),
    'start_datetime': convertDateToISOWithOffset(newStartDate),
    'end_datetime': convertDateToISOWithOffset(newEndDate),
    'user': appointment.user.id,
    'appointment_reason': reasonId[0].id,
    'cancel_or_reschedule_reason': 'Availability'
  });
}

export function getAppointmentById(id: number) {
  const url = `${getappointmentsUrl()}${id}`;
  return getRequest<Appointment>(url);
}




export const useDebounce = (value: string, delay: number) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    // 🔥 If input is empty, immediately clear the debounced value
    if (value.trim() === '') {
      setDebouncedValue('');
      return;
    }

    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getVisitLogs(patientId: number | null = null, query: string = ''): Promise<any> {
  const url = `${previousVisitLogs(patientId)}&${query}`;
  return getRequest(url, { responseType: 'json' });
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getRooms(query = ''): Promise<any> {
  const url = departmentRooms(query);
  return getRequest(url, { responseType: 'json' });
}

export function getWorkingHours(start: string, end: string, query:string = '') {
  return getRequest(`${getWorkingHoursURL()}?start_date__gte=${start}&end_date__lte=${end}&${query}`);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getgeneralsystemexamination(patientId: number): Promise<any> {
  return getRequest(getputgeneralsystemexaminationURL(patientId), { responseType: 'json' });
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function putgeneralsystemexamination(patientId: number, generalsystemexamination: any): Promise<any> {
  return putRequest(getputgeneralsystemexaminationURL(patientId), generalsystemexamination);
}


// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function geturogenitalexamination(patientId: number): Promise<any> {
  return getRequest(getputurogenitalexaminationURL(patientId), { responseType: 'json' });
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function puturogenitalexamination(patientId: number, urogenitalexamination: any): Promise<any> {
  return putRequest(getputurogenitalexaminationURL(patientId), urogenitalexamination);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getinfertilityassessment(patientId: number): Promise<any> {
  return getRequest(getputinfertilityassessmentURL(patientId), { responseType: 'json' });
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function putinfertilityassessment(patientId: number, infertilityassessment: any): Promise<any> {
  return putRequest(getputinfertilityassessmentURL(patientId), infertilityassessment);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getvital(patientId: number): Promise<any> {
  return getRequest(getputvitalURL(patientId), { responseType: 'json' });
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function putvital(patientId: number, vital: any): Promise<any> {
  return putRequest(getputvitalURL(patientId), vital);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getOTtables(query = ''): Promise<any> {
  const url = operationTheaterTables(query);
  return getRequest(url, { responseType: 'json' });
}


// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function updateAppointmentStatus(id: number, status: string): Promise<any> {
  const url = `${getappointmentsUrl()}${id}/status/`;
  const requestBody = {
    'status': status
  };

  // temp added; after status issue fixed I'll remove it



  return putRequest(url, requestBody);
}

export function getUsersByClinic(id: string, dep?: string | null, role?:string, limit?: string | null): Promise<PaginatedResponse<UserBasic[]>> {
  return getRequest(get_users_clinic(id, dep ?? null, role ?? null, limit ?? null));
}

export function getUsersByClinicAndTime(
  id: string,
  dep: string | null,
  timeFrom: string,
  timeTo: string
): Promise<PaginatedResponse<UserBasic[]>> {
  return getRequest(
    `${get_users_clinic(id, dep)}&start_datetime=${encodeURIComponent(timeFrom)}&end_datetime=${encodeURIComponent(timeTo)}`
  );
}

export function getUsersByClinicOnly(id: string): Promise<PaginatedResponse<UserBasic[]>> {
  return getRequest(get_users_clinic_only(id));
}

export function postpastillness(data: PastIllnessDetail): Promise<string> {
  return postRequest(postpastillnessUrl(), data, { responseType: 'json' });
}

export function getPastIllness(patient_id: number, limit?: number, offset?: number): Promise<PaginatedResponse<PastIllnessDetail[]>> {
  return getRequest(getpastillnessUrl(patient_id, limit, offset));
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getputpastillness(id: number): Promise<any> {
  return getRequest(getputpastillnessUrl(id));
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function updatePastIllness(id: number, payload: any): Promise<any> {
  return putRequest(getputpastillnessUrl(id), payload);
}


// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getSurgicalHistory(patientId: number): Promise<any> {
  return getRequest(getputSurgicalHistoryURL(patientId), { responseType: 'json' });
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function putSurgicalHistory(patientId: number, SurgicalHistory: any): Promise<any> {
  return putRequest(getputSurgicalHistoryURL(patientId), SurgicalHistory);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getLabTests(queryParam:string): Promise<any>{
  return getRequest(getLabTestsURL(queryParam));
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getLabTestsCats(queryParam:string): Promise<any>{
  return getRequest(getLabTestsCatsURL(queryParam));
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function addLabTestsCats(data:any): Promise<any>{
  return postRequest(getLabTestsCatsURL(''),data);
}

export function addInvestigation(data:CreateInvestigation):Promise<CreateInvestigation>{
  return postRequest(addinvestigationURL(''), data);
}
export function deleteInvestigation(data:number):Promise<CreateInvestigation>{
  return deleteRequest(deleteInvestigationURL(data), );
}

export function getInvestigation(query:string):Promise<PaginatedResponse<PatientInvestigationDetail[]>>{
  return getRequest(addinvestigationURL(query));
}
export function bookOutOfOffice(request: OutOfOfficeRequest): Promise<Appointment> {
  return postRequest(getWorkingHoursURL(), request);
}



export function getUsersByClinicId(query: string): Promise<PaginatedResponse<UserBasic[]>> {
  return getRequest(get_users_by_clinic(query));
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getProcedures(queryParam:string): Promise<any>{
  return getRequest(getProceduresURL(queryParam));
}

export function getAdminConsoleToken(): Promise<AdminConsoleToken> {
  return getRequest(getAdminUrl(), { responseType: 'json' });
}


// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function uploadOocyteFileURL(req: File_Source_Req, file: File):Promise<any> {
  return postRequest<File_Source_Res>(getOocyteUploadURL(), req, { responseType: 'text' })
    .then((response: File_Source_Res) => { 
      return uploadFileToS3(file, response.presigned_url);
    });
}



// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function uploadEmbryoFileURL(req: File_Source_Req, file: File):Promise<any> {
  return postRequest<File_Source_Res>(getEmbryoUploadURL(), req, { responseType: 'text' })
    .then((response: File_Source_Res) => { 
      return uploadFileToS3(file, response.presigned_url);
    });
}

export const getMasterData = async (url: string): Promise<MasterItem[]> => {
  const data = await getRequest(url, { responseType: 'json' });
  return data as MasterItem[];
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getIdentityProofs = async (): Promise<any> => {
  return getRequest('identity_proofs/', { responseType: 'json' });
};

// RFID Card Assignment
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function assignRfidCard(data: { patient_id: number; uid: string }): Promise<any> {
  return postRequest('https://staging-use1-api.vidaisolutions.com/api/rfid/scan/', data, { responseType: 'json' });
}


/**
 * Calls the patients/lms_update/ endpoint with patient_id and clinic_id.
 * @param patientId - The patient ID (number or string)
 * @param clinicId - The clinic ID (string)
 * @returns Promise<any> - The API response
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function postPatientLmsUpdate(patientId: number | string, clinicId: string): Promise<any> {
  const url = 'patients/lms_update/';
  const data = {
    patient_id: patientId,
    clinic_id: clinicId
  };
  return postRequest(url, data, { responseType: 'json' });
}

// ============================================
// Live Birth Prediction API
// ============================================


/**
 * Generate Live Birth Prediction using AI service directly
 * Calls the AI service to avoid backend proxy timeout
 * @param payload - The prediction request parameters
 * @returns Promise with prediction response
 */
export async function generateLiveBirthPrediction(
  payload: LiveBirthPredictionRequest
): Promise<LiveBirthPredictionResponse> {
  const response = await axios.post<LiveBirthPredictionResponse>(
    `${AI_SERVICE_BASE_URL}/live_birth/predict/full`,
    payload,
    { timeout: 60000, headers: { 'Content-Type': 'application/json' } }
  );
  return response.data;
}

/**
 * Send a follow-up chat question about a patient's live birth prediction
 * Calls the AI service directly to avoid backend proxy timeout
 * @param payload - The chat request with question, patient data, and cached prediction
 * @returns Promise with prediction response including answer
 */
export async function sendLiveBirthChat(
  payload: LiveBirthChatRequest
): Promise<LiveBirthPredictionResponse> {
  const response = await axios.post<LiveBirthPredictionResponse>(
    `${AI_SERVICE_BASE_URL}/live_birth/chat`,
    payload,
    { timeout: 60000, headers: { 'Content-Type': 'application/json' } }
  );
  return response.data;
}

/**
 * Fetch patient cycle data for Live Birth Prediction
 * Returns cycle data to pre-populate the prediction form
 * @param patientId - The patient ID to fetch cycle data for
 * @returns Promise with patient cycle data or null if not found
 */
export async function fetchPatientCycleData(
  patientId: number
): Promise<PatientCycleData | null> {
  try {
    const response = await getRequest<PatientCycleData>(
      `cycle/ai-live-prediction/?patient_id=${patientId}`
    );
    return response;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn(`No cycle data found for patient ${patientId}:`, error);
    return null;
  }
}